import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Employee } from '../../model/employee';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';

declare var Materialize: any;

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.css'],
  providers: [DBService]
})
export class NewUserComponent implements OnInit {

  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  employee: Employee;

  successMessage: string;
  errorMessage: string;

  loading: boolean;

  companies: Company[];

  isCustomer: boolean;

  userCompanyUID: string;
  isAdminUser: boolean;

  constructor(private router: Router, private authService: AuthenticationService, private dbService: DBService) {
    
    this.isAdminUser = this.authService.isAdmin();

    this.employee = new Employee();

    this.loading = true;

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.loadCompanies();
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
        } else {
          this.companies = companies;
        }
        this.loading = false;
      });
  }

  ngOnInit() {
  }

  register() {
    delete this.errorMessage;
    delete this.successMessage;

    this.loading = true;

    if (this.employee.isUser) {
      this.employee.password = `Sx'lV$055472\2aU1&J,0c.Mr9K84D`;
      this.authService.createUserAndRegister(this.employee)
        .then(() => {
          this.authService.sendRecoveryPasswordEmail(this.employee.email);
          this.registerSuccess();
        })
        .catch(error => this.registerError(error));
    } else {
      this.authService.createEmployee(this.employee)
        .then(() => this.registerSuccess())
        .catch(error => this.registerError(error));
    }
  }

  private registerSuccess() {
    this.loading = false;

    Materialize.toast('Usuário cadastrado com sucesso', 2000);

    this.router.navigate(['/usuarios']);
  }

  private registerError(error) {
    console.log('registerError init');
    this.loading = false;
    this.errorMessage = error;
  }

  cancel() {
    this.router.navigate(['/usuarios']);
  }

  isAdminChanged() {
    if (this.employee.isCompanyAdmin) {
      this.employee.isUser = true;
    }
  }

  hasAccessChanged() {
    if (!this.employee.isUser) {
      this.employee.isCompanyAdmin = false;
    }
  }

  companyChanged() {
    this.isCustomer = this.employee.companyUID && this.employee.companyUID !== 'I-Ganhei';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/new-user/new-user.component.ts